<div class="b-f-repeatsingle-initialinput">
  <label [for]="field.id" class="b-f-repeatsingle-initialinput-label">{{
    props.label
  }}</label>
  <div class="b-f-repeatsingle-initialinput-item">
    <input
      [type]="props.type ? props.type : 'text'"
      min="0"
      autocomplete="off"
      [placeholder]="props.placeholder"
      pInputText
      [(ngModel)]="input"
    />
    <button
      pButton
      *ngIf="!props['readOnly']"
      (click)="addFieldWithValue()"
      type="button"
      class="p-button-rounded b-f-repeatsingle-actionbutton b-f-repeatsingle-actionbutton-add"
      icon="symbol-add"
    ></button>
  </div>
</div>
<div
  *ngIf="field.fieldGroup"
  cdkDropList
  (cdkDropListDropped)="drop($event)"
  class="b-f-repeatsingle-additionalinputs"
>
  <div
    *ngFor="let newfield of field.fieldGroup; let i = index"
    class="b-f-repeatsingle-additionalinput"
    cdkDrag
  >
    <div
      *ngIf="props['enableReorder']"
      cdkDragHandle
      class="b-f-repeatsingle-draghandle symbol-drag-handle"
    ></div>
    <formly-field [field]="newField(newfield)"></formly-field>
    <ng-template cdkDragPreview>
      <div class="b-f-repeatsingle-dragpreview">
        <div
          *ngIf="props['enableReorder']"
          class="b-f-repeatsingle-draghandle symbol-drag-handle"
        ></div>
        <formly-field [field]="newField(newfield)"></formly-field>
        <div class="repeat-remove-container">
          <button
            pButton
            *ngIf="!props['readOnly']"
            (click)="remove(i)"
            type="button"
            class="p-button-rounded b-f-repeatsingle-actionbutton b-f-repeatsingle-actionbutton-remove"
            icon="symbol-remove"
          ></button>
        </div>
      </div>
    </ng-template>
    <div class="repeat-remove-container">
      <button
        pButton
        *ngIf="!props['readOnly']"
        (click)="remove(i)"
        type="button"
        class="p-button-rounded b-f-repeatsingle-actionbutton b-f-repeatsingle-actionbutton-remove"
        icon="symbol-remove"
      ></button>
    </div>
  </div>
</div>
